import { useQuery } from 'react-query';
import * as api from '../../services/api';
import { LONG_POLLING_INTERVAL } from '../../constants';
import useAccount from './useAccount';

const useRequestsStats = () => {
  const { accountId } = useAccount();
  const storeKey = ['requests', accountId, 'stats'];

  const { isLoading, data } = useQuery(storeKey, () => api.fetchRequestsStats({ accountId }), {
    refetchInterval: LONG_POLLING_INTERVAL,
    enabled: !!accountId
  });

  return {
    isLoading,
    stats: data?.data || { numOfPending: 0 }
  };
};

export default useRequestsStats;
